export default __webpack_public_path__ + "static/logo-61e8ab518815cee2b6b20901ea7fa407.svg";